<template>
  <div class="manage">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách câu hỏi - trả lời</h6>
          <a-button type="primary" @click="createQuestionAnswer" class="ml-20">Thêm mới</a-button>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChangePage"
        rowKey="id"
      >
        <template slot="active" slot-scope="row">
          <a-switch
            v-model="row.active"
            :loading="row.loadingActive"
            @change="handleUpdateActive(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <a-button shape="circle" @click="updateQuestionAnswer(row)" icon="edit" size="small" />
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="remove(row)"
            >
              <template slot="title">
                <p>Xóa câu hỏi - trả lời</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
    <ControllerQuestionAnswer :visible="visible" @close="visible = false" :resource="selectedQuestionAnswer" @reload="reloadData"/>
  </div>
</template>

<script>
import {fetchQuestionAnswer, updateQuestionAnswer, removeQuestionAnswer } from '@/services/landing-page/contact/question-answer'
import ControllerQuestionAnswer from './ControllerQuestionAnswer'
  export default {
    name: 'ContactQuestionAnwser',
    components: {
      ControllerQuestionAnswer
    },
    data() {
      return {
        callingAPI: true,
        dataSource: [],
        columns: [
          {
            title: 'Câu hỏi',
            dataIndex: 'question',
            scopedSlots: { customRender: 'question' },
            class: 'font-semibold',
            width: '300px'
          },
          {
            title: 'Trả lời',
            dataIndex: 'answer',
            scopedSlots: { customRender: 'answer' },
            class: 'font-semibold',
            width: '400px'
          },
          {
            title: 'Hiển thị',
            scopedSlots: { customRender: 'active' },
            width: 100,
          },
          {
            title: '',
            scopedSlots: { customRender: 'action' },
            width: 50,
          },
        ],
        pagination: {
          total: 0,
          pageSize: 5,
          current: 1
        },
        
        visible: false,
        selectedQuestionAnswer: null
      }
    },
    beforeMount() {
      this.loadData()
    },
    methods: {
      async loadData() {
        try {
          this.callingAPI = true
          const params = {
            per_page: this.pagination.pageSize,
            page: this.pagination.current
          }
          const response = await fetchQuestionAnswer(params)
          this.dataSource = response.data.data.map((d) => ({
            ...d,
            active: d.active == 1,
            loadingActive: false
          }))
          this.pagination.total = response.data.total 
          this.callingAPI = false
        } catch (error) {
          this.callingAPI = false
          console.log(error)
        }
      },

      createQuestionAnswer() {
        this.selectedQuestionAnswer = null
        this.visible = true
      },

      updateQuestionAnswer(row) {
        this.selectedQuestionAnswer = row
        this.visible = true
      },

      reloadData() {
        this.pagination.current = 1
        this.loadData()
      },

      async handleTableChangePage(pagination) {
      this.pagination.current = pagination.current;
      await this.loadData();
    },

      async handleUpdateActive(row) {
        const index = this.dataSource.findIndex((r) => r.id === row.id)
        try {
          this.dataSource[index].loadingActive = true
          const data = {
            question: row.question,
            answer: row.answer,
            active: row.active ? 1 : 2
          }
          const response = await updateQuestionAnswer(row.id, data)
          this.dataSource[index].loadingActive = false
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Cập nhật trạng thái hiển thị thành công.',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Cập nhật trạng thái hiển thị thất bại.',
            });
          }
        } catch (error) {
          console.log(error);
          this.dataSource[index].loadingActive = false
          this.$notification.error({
            message: 'Thất bại',
            description: 'Cập nhật trạng thái hiển thị thất bại.',
          });
        }
      },

      async remove(row) {
        try {
          const response = await removeQuestionAnswer(row.id)
          this.loadData()
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>